// libraries
import { CheckmarkSolidIcon } from '@interstate/components/Icons/CheckmarkSolidIcon';
import { MinusSmallIcon } from '@interstate/components/Icons/MinusSmallIcon';

export const DefaultFallback = MinusSmallIcon;
export const UpfrontTrue = CheckmarkSolidIcon;
